// ID: 121 TO 210

const WomenWear = 
{
  ApiCategory: "WomensWear",
  WomenKurtiData: [
    {
      id: 121,
      brand: "Abc",
      name: " Westside Lime Green Striped A-Line Kurta",
      main_img: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020086842_437Wx649H_202311150348471.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020086842_437Wx649H_202311150348462.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020086842_437Wx649H_202311150348483.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020086842_437Wx649H_202311150348444.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020086842_437Wx649H_202311150348471.jpeg',
      price: 1299,
      old_price: "₹1899",
      price_off: "50% Off",
      category: "Kurta",
      rating: 2.3,
      qty: 1,


    },
    {
      id: 122,
      brand: "Abc",
      name: "W Coral Embroidered Straight Kurta",
      main_img: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016540961_437Wx649H_202302160000001.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016540961_437Wx649H_202302160000372.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016540961_437Wx649H_202302152359573.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016540961_437Wx649H_202302152359594.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016540961_437Wx649H_202302152359565.jpeg',
      price: 759,
      old_price: "₹1899",
      price_off: "60% Off",
      category: "Kurta",
      rating: 3.2,
      qty: 1,

    },
    {
      id: 123,
      brand: "Abc",
      name: "Biba Blue Cotton Printed Straight Kurta",
      main_img: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016134763_437Wx649H_202301202255591.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016134763_437Wx649H_202301202256012.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016134763_437Wx649H_202301202255574.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016134763_437Wx649H_202301202255565.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i9/437Wx649H/MP000000016134763_437Wx649H_202301202256026.jpeg',
      price: 1339,
      old_price: "₹1999",
      price_off: "30% Off",
      category: "Kurta",
      rating: 2.6,
      qty: 1,

    },
    {
      id: 124,
      brand: "Abc",
      name: " Green Zardozi Embroidered Kurta ",
      main_img: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000019791007_437Wx649H_202310231115361.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000019791007_437Wx649H_202310231115372.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000019791007_437Wx649H_202310231115333.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000019791007_437Wx649H_202310231115354.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000019791007_437Wx649H_202310231115361.jpeg',
      price: 3799,
      old_price: "₹1899",
      price_off: "50% Off",
      category: "Kurta",
      rating: 3.6,
      qty: 1,

    },
    {
      id: 125,
      brand: "Abc",
      name: "Blue A Line Kurta With Shrug",
      main_img: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000010827024_437Wx649H_202110070125011.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000010827024_437Wx649H_202110070125432.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000010827024_437Wx649H_202110070127394.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000010827024_437Wx649H_202110070129325.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000010827024_437Wx649H_202110070130296.jpeg',
      price: 1679,
      old_price: "₹3599",
      price_off: "50% Off",
      category: "Kurta",
      rating: 2.9,
      qty: 1,

    },
    {
      id: 126,
      brand: "Abc",
      name: "Blue Embroidered Straight Kurta",
      main_img: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000013386113_437Wx649H_202206110947041.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000013386113_437Wx649H_202206110947072.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000013386113_437Wx649H_202206110947113.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000013386113_437Wx649H_202206110947144.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000013386113_437Wx649H_202206110947175.jpeg',
      price: 1299,
      old_price: "₹2599",
      price_off: "50% Off",
      category: "Kurta",
      rating: 4.2,
      qty: 1,

    },
    {
      id: 127,
      brand: "Abc",
      name: "W Yellow Printed A Line Kurta",
      main_img: 'https://img.tatacliq.com/images/i10/437Wx649H/MP000000017354109_437Wx649H_202304260054111.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i10/437Wx649H/MP000000017354109_437Wx649H_202304260054072.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i10/437Wx649H/MP000000017354109_437Wx649H_202304260054103.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i10/437Wx649H/MP000000017354109_437Wx649H_202304260054144.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i10/437Wx649H/MP000000017354109_437Wx649H_202304260054135.jpeg',
      price: 1234,
      old_price: "₹1899",
      price_off: "35% Off",
      category: "Kurta",
      rating: 3.8,
      qty: 1,

    },
    {
      id: 128,
      brand: "Abc",
      name: " Maroon Embroidered Fit & Flare Kurta",
      main_img: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000011683527_437Wx649H_202201061128371.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000011683527_437Wx649H_202201061128382.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000011683527_437Wx649H_202201061128404.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000011683527_437Wx649H_202201061128425.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000011683527_437Wx649H_202201061128371.jpeg',
      price: 1799,
      old_price: "₹3599",
      price_off: "50% Off",
      category: "Kurta",
      rating: 2.6,
      qty: 1,

    },
    {
      id: 129,
      brand: "Abc",
      name: " Globus Maroon Embroidered Kurta",
      main_img: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020213002_437Wx649H_202311232032281.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020213002_437Wx649H_202311232032322.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020213002_437Wx649H_202311232032303.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020213002_437Wx649H_202311232032264.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020213002_437Wx649H_202311232032195.jpeg',
      price: 1274,
      old_price: "₹1699",
      price_off: "25% Off",
      category: "Kurta",
      rating: 2.9,
      qty: 1,

    },
    {
      id: 130,
      brand: "Abc",
      name: "Globus White & Blue Cotton Printed Kurta",
      main_img: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020212929_437Wx649H_202311232029551.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020212929_437Wx649H_202311232029592.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020212929_437Wx649H_202311232030013.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020212929_437Wx649H_202311232029514.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020212929_437Wx649H_202311232029586.jpeg',
      price: 1124,
      old_price: "₹1499",
      price_off: "25% Off",
      category: "Kurta",
      rating: 3.1,
      qty: 1,

    },
    {
      id: 131,
      brand: "Abc",
      name: " Pink Embroidered Straight Kurti",
      main_img: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020107108_437Wx649H_202311160500071.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020107108_437Wx649H_202311160500152.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020107108_437Wx649H_202311160500123.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020107108_437Wx649H_202311160500135.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020107108_437Wx649H_202311160500166.jpeg',
      price: 989,
      old_price: "₹1999",
      price_off: "51% Off",
      category: "Kurta",
      rating: 3.8,
      qty: 1,

    },
    {
      id: 132,
      brand: "Abc",
      name: "Kurti Embroidered Straight Blue Kurta",
      main_img: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118408_437Wx649H_202311172024581.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118408_437Wx649H_202311172025032.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118408_437Wx649H_202311172025003.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118408_437Wx649H_202311172025024.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118408_437Wx649H_202311172025055.jpeg',
      price: 1649,
      old_price: "₹3299",
      price_off: "50% Off",
      category: "Kurta",
      rating: 2.9,
      qty: 1,

    },
    {
      id: 133,
      brand: "Abc",
      name: " Biba Beige Printed A Line Kurta",
      main_img: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000009671821_437Wx649H_202105300510201.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000009671821_437Wx649H_202105300510212.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000009671821_437Wx649H_202105300510223.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000009671821_437Wx649H_202105300510244.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i7/437Wx649H/MP000000009671821_437Wx649H_202105300510255.jpeg',
      price: 1299,
      old_price: "₹2599",
      price_off: "50% Off",
      category: "Kurta",
      rating: 2.3,
      qty: 1,

    },
    {
      id: 134,
      brand: "Abc",
      name: "Olive Green Geometric Print Straight Kurta",
      main_img: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014403962_437Wx649H_202209100520061.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014403962_437Wx649H_202209100520072.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014403962_437Wx649H_202209100520104.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014403962_437Wx649H_202209100520104.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014403962_437Wx649H_202209100520136.jpeg',
      price: 849,
      old_price: "₹1699",
      price_off: "50% Off",
      category: "Kurta",
      rating: 3.6,
      qty: 1,

    },
    {
      id: 135,
      brand: "Abc",
      name: "W Green & Pink Printed A Line Kurta",
      main_img: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014190806_437Wx649H_202208210000401.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014190806_437Wx649H_202208210000422.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014190806_437Wx649H_202208210000464.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014190806_437Wx649H_202208210000495.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014190806_437Wx649H_202208210000516.jpeg',
      price: 949,
      old_price: "₹1899",
      price_off: "50% Off",
      category: "Kurta",
      rating: 3.8,
      qty: 1,

    },
    {
      id: 136,
      brand: "Abc",
      name: "Biba Green Cotton Printed Straight Kurta",
      main_img: 'https://img.tatacliq.com/images/i11/437Wx649H/MP000000017856181_437Wx649H_202306072118331.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i11/437Wx649H/MP000000017856181_437Wx649H_202306072118362.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i11/437Wx649H/MP000000017856181_437Wx649H_202306072118394.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i11/437Wx649H/MP000000017856181_437Wx649H_202306072118385.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i11/437Wx649H/MP000000017856181_437Wx649H_202306072118316.jpeg',
      price: 1199,
      old_price: "₹1999",
      price_off: "40% Off",
      category: "Kurta",
      rating: 2.4,
      qty: 1,

    },
    {
      id: 137,
      brand: "Abc",
      name: "Red Cotton Printed Angrakha Kurta",
      main_img: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118418_437Wx649H_202311172025071.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118418_437Wx649H_202311172025112.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118418_437Wx649H_202311172025133.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118418_437Wx649H_202311172025154.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020118418_437Wx649H_202311172025145.jpeg',
      price: 1299,
      old_price: "₹2599",
      price_off: "50% Off",
      category: "Kurta",
      rating: 2.9,
      qty: 1,

    },
    {
      id: 138,
      brand: "Abc",
      name: " Purple Geometric Print Straight Kurta",
      main_img: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014404246_437Wx649H_202209100552081.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014404246_437Wx649H_202209100552102.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014404246_437Wx649H_202209100552134.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014404246_437Wx649H_202209100552145.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i8/437Wx649H/MP000000014404246_437Wx649H_202209100552156.jpeg',
      price: 899,
      old_price: "₹1799",
      price_off: "50% Off",
      category: "Kurta",
      rating: 2.8,
      qty: 1,

    },
    {
      id: 139,
      brand: "Abc",
      name: " Aurelia Grey Cotton Printed Straight Kurta",
      main_img: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200970_437Wx649H_202311230420181.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200970_437Wx649H_202311230420212.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200970_437Wx649H_202311230420203.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200970_437Wx649H_202311230420254.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200970_437Wx649H_202311230420245.jpeg',
      price: 1599,
      old_price: "₹1899",
      price_off: "50% Off",
      category: "Kurta",
      rating: 2.5,
      qty: 1,

    },
    {
      id: 140,
      brand: "Abc",
      name: "Aurelia Off-White Straight Short Kurti",
      main_img: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200968_437Wx649H_202311230420231.jpeg',
      item_img_1: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200968_437Wx649H_202311230420202.jpeg',
      item_img_2: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200968_437Wx649H_202311230420193.jpeg',
      item_img_3: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200968_437Wx649H_202311230420214.jpeg',
      item_img_4: 'https://img.tatacliq.com/images/i14/437Wx649H/MP000000020200968_437Wx649H_202311230420255.jpeg',
      price: 759,
      old_price: "₹1899",
      price_off: "60% Off",
      category: "Kurta",
      rating: 3.6,
      qty: 1,

    },
    // {
    //   id: 141,
    //   brand: "AbcDSK STUDIO",
    //   name: "Women Crepe Kurta Dupatta Set",
    //   main_img: 'https://i.postimg.cc/TPs7SZkk/original-imagw6sczmhwxasq.jpg',
    //   item_img_1: 'https://i.postimg.cc/wj0b5tDY/original-imagw6scvpgjhnx5.jpg',
    //   item_img_2: 'https://i.postimg.cc/pTnGtq4P/original-imagw6sc9g2dzsyy.jpg',
    //   item_img_3: 'https://i.postimg.cc/SxyvzL2G/original-imagw6sczhyh6mhf.jpg',
    //   item_img_4: 'https://i.postimg.cc/FKzCT9xd/original-imagw6scry5d2xuz.jpg',
    //   price: 299,
    //   old_price: "₹999",
    //   price_off: "70% Off",
    //   category: "Kurta",
    //   rating: 3.6,
    // qty: 1,

    // },
    // {
    //   id: 142,
    //   brand: "AbcDSK STUDIO",
    //   name: "Women Crepe Kurta Dupatta Set",
    //   main_img: 'https://i.postimg.cc/0NHk4yRL/l-a-dupatta-410-dsk-studio-original-imagtg4ezz527hnb.jpg',
    //   item_img_1: 'https://i.postimg.cc/7hSqb1Gk/xxl-a-dupatta-401-dsk-studio-original-imagtg358s9nr8vu.jpg',
    //   item_img_2: 'https://i.postimg.cc/rppygtb1/xxl-a-dupatta-401-dsk-studio-original-imagtg35aduqnvaf.jpg',
    //   item_img_3: 'https://i.postimg.cc/0QMk119r/xxl-a-dupatta-401-dsk-studio-original-imagtg35cphzyvhe.jpg',
    //   item_img_4: 'https://i.postimg.cc/mDvbbprj/xxl-a-dupatta-401-dsk-studio-original-imagtg35scaahprm.jpg',
    //   price: 299,
    //   old_price: "₹1299",
    //   price_off: "76% Off",
    //   category: "Kurta",
    //   rating: 3.6,
    // qty: 1,

    // },
  ],
  
  WomenTopData : [
    {
      id: 151,
      brand: "Shopster",
      name: "Casual Bishop Sleeve Printed Women Light Blue Top",
      main_img:
        "https://i.postimg.cc/XYfntDK6/w1-1.jpg",
      item_img_1:
        "https://i.postimg.cc/NF2cDNGV/w1-2.jpg",
      item_img_2:
        "https://i.postimg.cc/76W4gv40/w1-3.jpg",
      item_img_3:
        "https://i.postimg.cc/tg99btDZ/w1-4.jpg",
      item_img_4:
        "https://i.postimg.cc/LXXRY9cm/w1-5.jpg",
      price: 539,
      old_price: "₹1499",
      price_off: "64% Off",
      category: "Top",
      rating: 4.6,
      // qty: 1,
    },
    {
      id: 152,
      brand: "Shopster",
      name: "Casual Regular Sleeves Self Design Women Dark Green Top",
      main_img:
        "https://i.postimg.cc/pLHm9jqx/w2-1.jpg",
      item_img_1:
        "https://i.postimg.cc/7Y7CY91m/w2-2.jpg",
      item_img_2:
        "https://i.postimg.cc/xjBJ2hmX/w2-3.jpg",
      item_img_3:
        "https://i.postimg.cc/k5MDsd0p/w2-4.jpg",
      item_img_4:
        "https://i.postimg.cc/3xFd2wcG/w2-5.jpg",
      price: 302,
      old_price: "₹2499",
      price_off: "87% Off",
      category: "Top",
      rating: 3.5,
      // qty: 1,
    },
    {
      id: 153,
      brand: "Shopster",
      name: "Casual Regular Sleeves Solid Women Yellow Top",
      main_img:
        "https://i.postimg.cc/HL3dkcPS/w3-1.jpg",
      item_img_1:
        "https://i.postimg.cc/NM5Fhkf8/w3-2.jpg",
      item_img_2:
        "https://i.postimg.cc/j5m5RnLp/w3-3.jpg",
      item_img_3:
        "https://i.postimg.cc/4NCdMtCt/w3-4.jpg",
      item_img_4:
        "https://i.postimg.cc/Y0FS02Fh/w3-5.jpg",
      price: 423,
      old_price: "₹899",
      price_off: "52% Off",
      category: "Top",
      rating: 3.5,
      // qty: 1,
    },
    {
      id: 154,
      brand: "Shopster",
      name: "Men Solid Single Breasted Casual Blazer",
      main_img:
        "https://i.postimg.cc/CMn5m72S/w4-1.jpg",
      item_img_1:
        "https://i.postimg.cc/6pcpym8L/w4-2.jpg",
      item_img_2:
        "https://i.postimg.cc/tChTHTyc/w4-3.jpg",
      item_img_3:
        "https://i.postimg.cc/RZ40CBZZ/w4-4.jpg",
      item_img_4:
        "https://i.postimg.cc/5ttNvSvc/w4-5.jpg",
      price: 232,
      old_price: "₹599",
      price_off: "61% Off",
      category: "Top",
      rating: 4.1,
      // qty: 1,
    },
    {
      id: 155,
      brand: "Shopster",
      name: "Casual Regular Sleeves Floral Print Women White Top",
      main_img:
        "https://i.postimg.cc/qMCJx7zR/w5-1.jpg",
      item_img_1:
        "https://i.postimg.cc/Z5tT7hdL/w5-2.jpg",
      item_img_2:
        "https://i.postimg.cc/Yjcws1hS/w5-3.jpg",
      item_img_3:
        "https://i.postimg.cc/jj82kFKd/w5-4.jpg",
      item_img_4:
        "https://i.postimg.cc/sfMQbsMF/w5-5.jpg",
      price: 534,
      old_price: "₹999",
      price_off: "46% Off",
      category: "Top",
      rating: 3.9,
      // qty: 1,
    },
  ],
  
  WomenBottomData : [
    {
      id: 181,
      brand: "Shopster",
      name: "Women Skinny Mid Rise Blue Jeans",
      main_img:
        "https://i.postimg.cc/XJk3X276/wb1-1.jpg",
      item_img_1:
        "https://i.postimg.cc/1XWQrfqW/wb1-2.jpg",
      item_img_2:
        "https://i.postimg.cc/hv4nm9fz/wb1-3.jpg",
      item_img_3:
        "https://i.postimg.cc/05ZPsHBp/wb1-4.jpg",
      item_img_4:
        "https://i.postimg.cc/X7J37cRt/wb1-5.jpg",
      price: 646,
      old_price: "₹1999",
      price_off: "67% Off",
      category: "Jeans",
      rating: 4.6,
      // qty: 1,
    },
    {
      id: 182,
      brand: "Shopster",
      name: "Women Regular Fit Pink Cotton Blend Trousers",
      main_img:
        "https://i.postimg.cc/Twg10qdt/wb2-1.jpg",
      item_img_1:
        "https://i.postimg.cc/4yGdS7ns/wb2-2.jpg",
      item_img_2:
        "https://i.postimg.cc/dQRDTBS1/wb2-3.jpg",
      item_img_3:
        "https://i.postimg.cc/FsDRTKvX/wb2-4.jpg",
      item_img_4:
        "https://i.postimg.cc/d391PsTd/wb2-5.jpg",
      price: 428,
      old_price: "₹1699",
      price_off: "74% Off",
      category: "Trousers",
      rating: 3,
      // qty: 1,
    },
    {
      id: 183,
      brand: "Shopster",
      name: "Women Boyfriend Mid Rise Blue Jeans",
      main_img:
        "https://i.postimg.cc/tCXJdxLz/wb3-1.jpg",
      item_img_1:
        "https://i.postimg.cc/W1z4CPpF/wb3-2.jpg",
      item_img_2:
        "https://i.postimg.cc/W1z4CPpF/wb3-2.jpg",
      item_img_3:
        "https://i.postimg.cc/B69QjLTH/wb3-4.jpg",
      item_img_4:
        "https://i.postimg.cc/CLQ0ZnY5/wb3-5.jpg",
      price: 834,
      old_price: "₹2599",
      price_off: "67% Off",
      category: "Jeans",
      rating: 3.9,
      // qty: 1,
    },
    {
      id: 184,
      brand: "Shopster",
      name: "Women Solid Grey Track Pants",
      main_img:
        "https://i.postimg.cc/vBr8fYhj/wb4-1.jpg",
      item_img_1:
        "https://i.postimg.cc/ZnJbLGDq/wb4-2.jpg",
      item_img_2:
        "https://i.postimg.cc/q7CvBX3p/wb4.jpg",
      item_img_3:
        "https://i.postimg.cc/WzS2Y5Qw/wb4-4.jpg",
      item_img_4:
        "https://i.postimg.cc/G3jhppHT/wb4-5.jpg",
      price: 439,
      old_price: "₹1149",
      price_off: "61% Off",
      category: "Track Pants",
      rating: 4.1,
      // qty: 1,
    },
    {
      id: 185,
      brand: "Shopster",
      name: "Women Tapered Blue Cotton Blend Trousers",
      main_img:
        "https://i.postimg.cc/Qx48pngX/wb5-1.jpg",
      item_img_1:
        "https://i.postimg.cc/jSDsvQvy/wb5-2.jpg",
      item_img_2:
        "https://i.postimg.cc/hGxKRDkj/wb5-3.jpg",
      item_img_3:
        "https://i.postimg.cc/RZ2vY6by/wb5-4.jpg",
      item_img_4:
        "https://i.postimg.cc/9MhCm32B/wb5-5.jpg",
      price: 539,
      old_price: "₹1999",
      price_off: "73% Off",
      category: "Trousers",
      rating: 3.9,
      // qty: 1,
    },
  ],

}

export default WomenWear;